import { cssClass } from '../../style';

const cssPrefix = 'LenSpaceStyles';

export namespace LensSpaceStyles {
  export const LensEditableTitleContainer = cssClass(cssPrefix, 'lens-editable-title-container', {
    display: 'flex',
    clear: 'both',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  });
}
